import { RULE_NAME_REGEX } from "@constants";

export const allCharactersValid = (testRuleName: string) => {
  return RULE_NAME_REGEX.test(testRuleName);
};
